<template>
  <div class="page-wrapper">
    <div class="viewpage-caption-container">
      <div class="title">Reports Download Center</div>
      <div class="actions-btns-container">
        <el-button type="primary" class="btn" @click="handleRefresh()">Refresh</el-button>
        <el-button type="success" plain class="btn" @click="handleBatchSend()">Batch SendXero</el-button>
        <el-upload
          action="/api/app/orders-import"
          :limit="1"
          accept="xlsx"
          :headers="uploadHeader"
          :on-success="handleBasicImportSuccess"
          :on-progress="handleBasicImportBegin"
          :on-error="hanndeBasicImportError"
          :show-file-list="false"
          :multiple="true"
          :style="{'margin-left': '8px'}"
        >
          <el-button size="mini" type="warning" plain>Import Draft Inv</el-button>
        </el-upload>
        <el-upload
          action="/api/app/import"
          :limit="1"
          accept="xlsx"
          :headers="uploadHeader"
          :on-success="handleBasicImportSuccess"
          :on-progress="handleBasicImportBegin"
          :on-error="hanndeBasicImportError"
          :show-file-list="false"
          :multiple="true"
          :style="{'margin-left': '8px'}"
        >
          <el-button size="mini" type="info" plain>Import Basic</el-button>
        </el-upload>
      </div>
    </div>
    <el-card>
      <el-table
        :data="data"
        :row-style="{height:'40px'}"
        border
        stripe
        size="mini"
        :header-cell-style="{background:'#D7D7D7',color:'#000'}"
      >
        <el-table-column prop="type" label="Name" width="300"></el-table-column>
        <el-table-column prop="dateRange" label="Date Range" width="300"></el-table-column>
        <el-table-column prop="createdAt" label="Applied At" width="300"></el-table-column>
        <el-table-column prop="state" label="State" width="150" align="center"></el-table-column>
        <el-table-column label="Opeartion">
          <template v-slot="scope">
            <el-button @click="handleDownload(scope.row)" size="mini">Download</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <DialogBatchSendXero
      :dialogVisible="BatchSendShow"
      @closed="BatchSendShow=false"
      @success="handleSuccess"
    />
  </div>
</template>

<script>
import { reports, download } from '../api'
import DialogBatchSendXero from '../components/DialogBatchSendXero'
import { mapState } from 'vuex'

export default {
  name: 'ReportDownload',
  data () {
    return {
      data: [],
      BatchSendShow: false,
      loading: ''
    }
  },
  computed: {
    ...mapState('oauth', ['accessToken']),
    ...mapState(['currentAccount']),
    uploadHeader () {
      return {
        // 'Content-type': 'application/json',
        Authorization: this.accessToken,
        'IWE-EID': this.currentAccount.eId
      }
    }
  },
  components: {
    DialogBatchSendXero
  },
  inject: ['reload'],
  created () {
    this.handleQuery()
  },
  methods: {
    async handleQuery () {
      const data = await reports()
      this.data = data.data
    },
    handleDownload (row) {
      const id = row.id
      const fileName = row.type + '-' + row.dateRange + '.xlsx'
      download(id, fileName)
    },
    handleRefresh () {
      this.reload()
    },
    handleBatchSend () {
      this.BatchSendShow = true
    },
    handleSuccess () {
      this.BatchSendShow = false
      this.handleRefresh()
    },
    handleBasicImportBegin () {
      this.loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading'
      })
    },
    handleBasicImportSuccess () {
      this.loading.close()
      this.$message({
        type: 'success',
        message: 'Operation Success'
      })
    },
    hanndeBasicImportError (res) {
      this.loading.close()
      this.$message({
        type: 'error',
        message: res.message || ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  max-width: 1678px;
}
.viewpage-caption-container {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  display: flex;
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.btn {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}
</style>
